<template lang="pug">
  m-table(
    store-name="admintemplates"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockAdminTemplates',
  components: { MTable },
  props: {
    entityId: {
      type: String,
      default: null
    },
    filterName: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'title',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        [this.filterName]: this.entityId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
